(function ($) {
    $(document).ready(function () {
        initializeAos();
        initializeMobileMenu();
        initializeMainSlider();
        initializeFancyBox();
        initializeSearchInput();
    });

    function initializeMobileMenu() {
        let menu = $(".mobile-menu").mmenu({
                extensions: ['theme-dark']
            }),
            icon = $(".hamburger"),
            api = menu.data('mmenu');

        icon.on('click', function () {
            api.open();
        });
    }

    function initializeMainSlider() {
        let slider = $(".main-slider")

        if (slider.length > 0) {
            slider.owlCarousel({
                smartSpeed: 400,
                items: 1,
                nav: true,
                dots: true,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                dotsContainer: '.owl-dots-container'
            });
        }
    }

    function initializeAos() {
        AOS.init({
            disable: 'mobile',
            once: true
        });
    }

    function initializeFancyBox() {
        let images = $('.text-container a > img'),
            galleries = $('a[data-fancybox]');

        if (images.length > 0) {
            images.each(function () {
                $(this).closest('a').fancybox();
            })
        }

        if (galleries.length > 0) {
            galleries.fancybox();
        }
    }

    function initializeSearchInput() {
        let input = $('.header__search-field');

        searchInputOperations(input);
        if (input.length > 0) {
            input.on('keyup', function () {
                searchInputOperations(input);
            });
        }
    }

    function searchInputOperations(input) {
        if (input.val().length > 0 && !input.hasClass('header__search-field--focused')) {
            input.addClass('header__search-field--focused');
        } else if (input.val().length < 1 && input.hasClass('header__search-field--focused')) {
            input.removeClass('header__search-field--focused');
        }
    }
})(jQuery);